import { render, staticRenderFns } from "./tab-container-minimal.vue?vue&type=template&id=080d5d91&"
import script from "./tab-container-minimal.vue?vue&type=script&lang=js&"
export * from "./tab-container-minimal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports